import { useEffect, useState } from 'react';
import { Modal } from "react-bootstrap";
import toast from 'react-hot-toast';
import CustomTextInput from '../../../components/CustomTextInput';
import { CikisDuzeltIstegi, MesaiKaydiItem, trTarih } from '../../../services/MesaiKaydiService';

interface Props {
    kayit: MesaiKaydiItem | undefined
    onConfirm: (_istek: CikisDuzeltIstegi) => void
    onClose: () => void
}

/**
 * Mesai Kayıtları > Çıkışı düzelt (MesaiKaydi/CikisDuzelt). Eksik çıkış ya da Tamam kayıtta çıkış saatini yetkili girer;
 * düzelten ve zaman kaydedilir, hesap ve sipariş o an yeniden oluşur.
 */
const CikisDuzeltModal = ({ kayit, onConfirm, onClose }: Props) => {
    const [cikis, setCikis] = useState<string>('');
    const [aciklama, setAciklama] = useState<string | undefined>('');

    useEffect(() => {
        if (kayit) {
            setCikis(kayit.cikisSaati ?? '');
            setAciklama('');
        }
    }, [kayit])

    const kaydet = () => {
        if (!kayit)
            return;

        if (!cikis) {
            toast.error('Çıkış saati zorunludur.');
            return;
        }

        onConfirm({ mesaiKaydiId: kayit.mesaiKaydiId, cikisSaati: cikis, aciklama: aciklama?.trim() || null });
    }

    return (
        <Modal
            tabIndex={-1}
            dialogClassName='modal-dialog modal-dialog-centered mw-500px'
            show={kayit != undefined}
            onHide={onClose}
            backdrop={'static'}
            keyboard={false}
        >
            <div className='modal-header'>
                <h2 className='mb-0'>Çıkışı Düzelt</h2>
            </div>

            <div className='modal-body'>
                {
                    kayit && (
                        <div className='mb-5 fs-6'>
                            <b>{kayit.kisiAdi}</b> · {trTarih(kayit.tarih)} · {kayit.noktaAdi}
                            <br />
                            <span className='text-muted'>Giriş {kayit.girisSaati} · Çıkış {kayit.cikisSaati ?? '—'} · {kayit.durumAdi}</span>
                        </div>
                    )
                }

                <div className='mb-5'>
                    <label className="form-label required">Çıkış saati</label>
                    <input
                        type="time"
                        className="form-control form-control-solid"
                        style={{ border: '1px solid #F1F1F4' }}
                        value={cikis}
                        onChange={(e) => setCikis(e.target.value)}
                    />
                </div>

                <div className='mb-5'>
                    <CustomTextInput labelText='Açıklama' value={aciklama} setValue={setAciklama} />
                </div>

                <div className='alert alert-primary d-flex align-items-start p-4 mb-0'>
                    <i className='fa fa-info-circle text-primary fs-3 me-3 mt-1'></i>
                    <div className='fs-7'>
                        Çıkış girişten önceyse gece yarısını geçmiş sayılır. Kaydedince ek mesai yeniden hesaplanır; atanmış bir ek mesai değişirse atama "yeniden ata" durumuna düşer.
                    </div>
                </div>
            </div>

            <div className="modal-footer">
                <button onClick={onClose} type="button" className="btn btn-light">
                    Vazgeç
                </button>
                <button onClick={kaydet} type="button" className="btn btn-success">
                    Kaydet
                </button>
            </div>
        </Modal>
    )
}

export default CikisDuzeltModal;
